export default __webpack_public_path__ + "static/media/instagram.1fc2cd0e.svg";